export enum StagedUploadHttpMethodType {
  Post = "POST",
  Put = "PUT",
}